import FieldValidationCodes from '@/lib/FieldValidationCodes';
import SaascadaVue from '@/components/Shared/SaascadaVue';

export default class SaascadaVueProductForm extends SaascadaVue {
  public FieldValidationCodes = FieldValidationCodes;
  public valid = true;
  public validate(field: string) {
    return this.validateField(field);
  }
  public validateForm() {
    if (this.$refs.form === undefined) {
      return;
    }
    return (this.$refs.form as any).validate();
  }
}
